var map = {
	"./High2.svg": "./src/assets/images/avatars/start/High2.svg",
	"./Primary2.svg": "./src/assets/images/avatars/start/Primary2.svg",
	"./Secondary2.svg": "./src/assets/images/avatars/start/Secondary2.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/avatars/start sync recursive ^\\.\\/.*2\\.svg$";